import { MapServerProvider } from 'providers/request'
import { Widget } from 'models/widget'
import { UrlUtils } from 'utils/url'

export const WidgetRepository = {
  fetchForLayer(layerId: number): Promise<Widget[]> {
    return MapServerProvider.get(`/layerWidgets/${layerId}`)
  },

  fetchForLayers(layerIds: number[]): Promise<Widget[]> {
    return Promise.all(
      layerIds.map((layerId) => MapServerProvider.get(`/layerWidgets/${layerId}`)),
    ).then((widgetsArr: Widget[][]) => {
      return widgetsArr.flat()
    })
  },

  fetch(widgetId: number, filters: any): Promise<any> {
    const filtersParams = UrlUtils.formatQueryParams(filters)

    return MapServerProvider.post(`/widgets/${widgetId}?${filtersParams}`, filters.filters)
  },

  downloadLayerCsv(projectId: string, layerId: number): Promise<File> {
    return MapServerProvider.get(`/getcsv/project/${projectId}/layer/${layerId}`, {
      headers: {
        Accept: 'text/csv',
      },
    })
  },
}
